import userGuide from '../downloads/migration-portfolio-assessment-user-guide.pdf';
import { constants } from './Localization';

export const userGuideUrl = userGuide;
const handsOnGuideUrl = 'https://catalog.workshops.aws/migrationimmersionday/en-US/apn/mpa';
const portfolioAssessmentGuideUrl = 'https://docs.aws.amazon.com/prescriptive-guidance/latest/application-portfolio-assessment-guide/introduction.html';

type AdditionalResource = {
    id: string;
    href: string;
    text: string;
};

export const coreResources: AdditionalResource[] = [
    {
        id: 'portfolioAssessmentGuide',
        href: portfolioAssessmentGuideUrl,
        text: constants.PORTFOLIO_ASSESSMENT_GUIDE,
    },
    {
        id: 'userGuide',
        href: userGuideUrl,
        text: constants.USER_GUIDE,
    },
    {
        id: 'handsOnGuide',
        href: handsOnGuideUrl,
        text: constants.HANDS_ON_GUIDE,
    },
    {
        id: 'faq',
        href: '/faq',
        text: constants.FAQ,
    },
];

export const userGuidePages: {[topic: string]: number} = {
    applicationCost: 43,
    assetAttributes: 11,
    ec2SQLServerLI: 31,
    ec2OracleBYOL: 32,
    dedicatedHost: 29,
    dedicatedHostLicenses: 30,
    mainframes: 48,
    recommendationsPriority: 22,
};

export const getUserGuidePage = (topic: string) => (userGuideUrl + '#page=' + userGuidePages[topic]);
